// components/common/LoaderOverlay.jsx
import React from 'react';
import { Center, Loader } from '@mantine/core';

const LoaderOverlay = ({ height = '100vh', size = 'xl' }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: height,
      backdropFilter: 'blur(5px)',
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      zIndex: 9999,
    }}>
      <Center h="100%">
        <Loader size={size} />
      </Center>
    </div>
  );
};

export default LoaderOverlay;

